import React, { useCallback, useState } from "react";
import { IconButton, ThumbUpOutlineIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { usePromptLogFeedback } from "~/repository";

export const VoteThumbs = ({ id, className }) => {
  const { mutate } = usePromptLogFeedback(id);
  const [voted, setVoted] = useState("undecided");

  const handleVote = useCallback(
    (event) => {
      const target = event.currentTarget.dataset.id;
      const data = { user_feedback: voted === target ? "undecided" : target };
      mutate(data, {
        onSuccess: (res) => {
          const {
            single: { user_feedback },
          } = res;
          setVoted(user_feedback);
        },
      });
    },
    [mutate, voted]
  );

  return (
    <div className={classNames("tw-flex tw-items-center tw-gap-3", className)}>
      <IconButton
        variant="option"
        size="small"
        onClick={handleVote}
        data-id="good"
        data-testid="up-vote"
      >
        <ThumbUpOutlineIcon
          className={classNames({
            "tw-text-theme-700": voted === "undecided",
            "tw-text-theme-900": voted === "good",
            "tw-text-theme-500": voted === "bad",
          })}
        />
      </IconButton>
      <IconButton
        variant="option"
        size="small"
        onClick={handleVote}
        data-id="bad"
        data-testid="down-vote"
      >
        <ThumbUpOutlineIcon
          className={classNames("tw-rotate-180", {
            "tw-text-theme-700": voted === "undecided",
            "tw-text-theme-900": voted === "bad",
            "tw-text-theme-500": voted === "good",
          })}
        />
      </IconButton>
    </div>
  );
};

VoteThumbs.propTypes = {
  id: PropTypes.number.isRequired,
  className: PropTypes.string,
};
